import { render, staticRenderFns } from "./profilecard.vue?vue&type=template&id=6fb26e68&"
import script from "./profilecard.vue?vue&type=script&lang=js&"
export * from "./profilecard.vue?vue&type=script&lang=js&"
import style0 from "./profilecard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports